import React from 'react';
import { withRouter } from 'react-router-dom';

import Navigation from '../Navigation/component-navigation';
import Body from './components/Body';

import Wrapper from '../Common/components/Wrapper';
import localStorage from '../Common/LocalStorage';
import { StaticRoutePaths } from '../Common/ClientRoutes';

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            role: ''
        };

        if (localStorage.getFromStorage('lang') === undefined) {
            localStorage.saveInStorage('lang', navigator.language.substring(0, 2));
        }
    }

    generateNavigation = pathName => {
        switch (pathName) {
            case StaticRoutePaths.LOGIN:
                return null;
            case StaticRoutePaths.LOGIN_FORGOTTEN_PASSWORD:
                return null;
            case StaticRoutePaths.LOGIN_RESET_PASSWORD:
                return null;
            case StaticRoutePaths.CREATE_PASSWORD:
                return null;
            case StaticRoutePaths.RESET_PASSWORD:
                return null;
            default:
                return <Navigation />;
        }
    };

    render() {
        return (
            <Wrapper>
                {this.generateNavigation(this.props.location.pathname)}
                <Body pathName={this.props.location.pathname} />
            </Wrapper>
        );
    }
}

export default withRouter(Layout);



// WEBPACK FOOTER //
// ./src/customModules/Layout/component-layout.js